import { query } from '@confluence/query-preloader-tools';
import { preloadSpacesDropdown } from '@confluence/spaces-dropdown/entry-points/preloadSpacesDropdown';

import { HomeLeftPanelAdministrationQuery } from '../LeftPanel/HomeLeftPanelAdministrationQuery.graphql';

import {
	getHomeProfileQueryOptions,
	getHomeHeaderImageQueryOptions,
} from './homeNavigationQueryHelpers';

export const preloadHomeNavigation = ({
	isLoggedIn,
	isLicensed,
	userId,
	cloudId,
	isMyVisitedSpacesEnabled,
	isHomeRefreshEnabled,
	isAdminCenterHomeEntryEnabled,
}: {
	isLoggedIn: boolean;
	isLicensed: boolean;
	userId: string;
	cloudId: string;
	isMyVisitedSpacesEnabled: boolean;
	isHomeRefreshEnabled: boolean;
	isAdminCenterHomeEntryEnabled: boolean;
}) => {
	if (isHomeRefreshEnabled && isAdminCenterHomeEntryEnabled) {
		// Spaces list and Administration section shown in the left navigation
		return Promise.all([
			preloadSpacesDropdown({ isLicensed, isMyVisitedSpacesEnabled }),
			preloadLeftPanelAdministrationQuery({ isLoggedIn }),
		]);
	} else if (isHomeRefreshEnabled) {
		// Spaces list is shown in the left navigation
		return preloadSpacesDropdown({ isLicensed, isMyVisitedSpacesEnabled });
	} else {
		// Profile data not used in the refresh
		return Promise.all([
			preloadProfileQuery({ isLoggedIn }),
			preloadHeaderImageQuery({ isLoggedIn, userId, cloudId }),
		]);
	}
};

const preloadProfileQuery = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
	const queryOptions = getHomeProfileQueryOptions({
		isLoggedIn,
		skip: false,
	});

	if (queryOptions.skip) {
		return Promise.resolve({});
	}

	return query(queryOptions);
};

const preloadHeaderImageQuery = ({
	isLoggedIn,
	userId,
	cloudId,
}: {
	isLoggedIn: boolean;
	userId: string;
	cloudId: string;
}) => {
	const queryOptions = getHomeHeaderImageQueryOptions({
		isLoggedIn,
		userId,
		cloudId,
		fetchPolicy: 'cache-first',
		skip: false,
	});

	if (queryOptions.skip) {
		return Promise.resolve({});
	}

	return query(queryOptions);
};

const preloadLeftPanelAdministrationQuery = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
	const queryOptions = {
		query: HomeLeftPanelAdministrationQuery,
		skip: !isLoggedIn,
	};
	return query(queryOptions);
};
